import { types } from 'mobx-state-tree'

export default types.model('DbProblemAuthorFilterModel', {
  subjectIds: types.optional(types.array(types.integer), []),
  studentIds: types.optional(types.array(types.string), []),
  levelIds: types.optional(types.array(types.integer), []),
  tagIds: types.optional(types.array(types.integer), [])
})
